import React from 'react';

import { BannerView } from '@knocklabs/react';

import { BodyRow, InlineHelpLink } from '../styles';
import { GuideActions, GuideHelpLink } from './shared';
import { BannerContent } from './types';
import { useVatixGuide } from './useVatixGuide';

export const VatixBanner: React.FC<{ guideKey?: string }> = ({ guideKey }) => {
  const { guide, step, colorMode, onDismiss, onButtonClick } = useVatixGuide<BannerContent>('banner', guideKey);

  if (!guide || !step) {
    return null;
  }

  const content = step.content;

  return (
    <BannerView.Root data-knock-color-mode={colorMode}>
      <BannerView.Content>
        {content.headline && <div className="knock-guide-banner__headline">{content.headline}</div>}
        <BannerView.Title title={content.title} />
        <BodyRow>
          <BannerView.Body body={content.body} />
          <GuideHelpLink helpLink={content.help_link} as={InlineHelpLink} />
        </BodyRow>
      </BannerView.Content>
      <GuideActions view={BannerView} content={content} onButtonClick={onButtonClick}>
        {content.dismissible && <BannerView.DismissButton onClick={onDismiss} />}
      </GuideActions>
    </BannerView.Root>
  );
};
